/**
 * Onboarding/guided-tour persistence.
 *
 * Auto-show rules this storage supports:
 *  - Guest: seen once per browser (lockedin_guest_onboarding_seen)
 *  - Registered user: per-uid localStorage fallback + Firestore users/{uid}.onboardingCompleted
 *  - Returning user with onboardingCompleted === true: never auto-show
 */

const GUEST_ONBOARDING_KEY = 'lockedin_guest_onboarding_seen';

function userOnboardingKey(uid) {
  return `lockedin_onboarding_completed_${uid}`;
}

function safeGet(key) {
  try {
    return window.localStorage.getItem(key);
  } catch (_) {
    return null;
  }
}

function safeSet(key, value) {
  try {
    window.localStorage.setItem(key, value);
  } catch (_) {
    /* ignore quota / privacy-mode errors */
  }
}

export function isGuestOnboardingSeen() {
  return safeGet(GUEST_ONBOARDING_KEY) === '1';
}

export function markGuestOnboardingSeen() {
  safeSet(GUEST_ONBOARDING_KEY, '1');
}

export function isOnboardingCompletedLocal(uid) {
  if (!uid) return false;
  return safeGet(userOnboardingKey(uid)) === '1';
}

export function markOnboardingCompletedLocal(uid) {
  if (!uid) return;
  safeSet(userOnboardingKey(uid), '1');
}

/**
 * True when onboarding should be considered already done for this viewer.
 * For registered users we treat either the Firestore field or the local
 * fallback as authoritative so a successful write or an offline session both
 * suppress the auto-show.
 */
export function isOnboardingCompleted(profileDoc, { isGuest = false, uid = null } = {}) {
  if (isGuest) return isGuestOnboardingSeen();
  if (profileDoc?.onboardingCompleted === true) return true;
  return isOnboardingCompletedLocal(uid);
}
